import { useState, useEffect } from 'react'
import { Icon } from '@iconify/react'
import { useNav, useParseQuery } from '../../../hooks/useNav'
import TableData from '../../../components/ui/TableData'
import { Button } from '../../../components/ui/legacy'
import { PAGE_SIZE } from '../../../data/queryFactories'
import useGetBooks from './hooks/useGetBooks'
import BookDetailModal from './BookDetailModal'
import { PATH } from '../../../data/router_path'
import { showErrorToast } from '../../../utils/showToast'
import ExportExcelBook from '../../../features/book-management/book-list/components/ExportExcelBook'
import { LuEye } from 'react-icons/lu'
import { MdVisibilityOff } from 'react-icons/md'
import { bookService } from '../../../service/BookService'
import ConfirmationBox from '../../../components/ui/ConfirmationBox'
import {
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../utils/showToast'
import { error } from 'pdf-lib'
export default function BookDataTable({ path }) {
  const [activeBook, setActiveBook] = useState(null)
  const navigate = useNav()
  const {
    data: { totalResult = 0, totalPages = 1, currentPage = 0, books = [] } = {},
  } = useGetBooks()
  const [activeModal, setActiveModal] = useState(false)
  const [checkStatus, setCheckStatus] = useState('')
  const detailViewFunction = (row) => {
    setActiveBook(row.uuid)
  }
  const columnMapping = [
    { key: 'title', value: 'Nhan đề' },
    { key: 'author', value: 'Tác giả' },
    { key: 'publishYear', value: 'Năm XB' },
    { key: 'subject', value: 'Học phần' },
    { key: 'major', value: 'Chuyên ngành' },
    { key: 'bookCollections', value: 'Gói sách' },
    { key: 'publisher', value: 'NXB' },
    { key: 'isbn', value: 'ISBN' },
    { key: 'description', value: 'Tóm tắt' },
    { key: 'pages', value: 'Số trang' },
    { key: 'price', value: 'Giá' },
  ]

  const columnWidths = {
    title: 'w-[10.83vw]',
    author: 'w-[7.92vw]',
    publishYear: 'w-[7.92vw]',
    subject: 'w-[7.92vw]',
    major: 'w-[7.92vw]',
    bookCollections: 'w-[7.92vw]',
    publisher: 'w-[7.92vw]',
    isbn: 'w-[7.92vw]',
    description: 'w-[7.92vw]',
    pages: 'w-[7.92vw]',
    price: 'w-[7.92vw]',
  }
  const handleDeactiveBook = async (row) => {
    setActiveModal(false)
    try {
      const getInfoBook = await bookService.getByUuid(row?.uuid)
      if (getInfoBook.success === true && getInfoBook.data) {
        try {
          const dataInfoBook = getInfoBook?.message?.content
          const dataUpdated = {
            ...dataInfoBook,
            status: dataInfoBook.status !== 'INACTIVE' ? 'INACTIVE' : 'ACTIVE',
            fileSize: dataInfoBook?.fileSize
              ? dataInfoBook.fileSize.replace(/\s*mb\s*/gi, '').trim()
              : '',
          }
          const textLoading =
            dataInfoBook.status !== 'INACTIVE'
              ? 'Đang vô hiệu hóa sách'
              : ' Đang kích hoạt sách'
          showLoadingToast(textLoading, toastKey.BOOKS_MANAGEMENT.LIST.DEACTIVE)
          const res = await bookService.update({
            uuid: row?.uuid,
            payload: dataUpdated,
          })
          const textSuccess =
            dataInfoBook.status !== 'INACTIVE'
              ? 'Vô hiệu hóa sách thành công'
              : 'Kích hoạt sách thành công'
          if (res.success === true && res.data) {
            showSuccessToast(
              textSuccess,
              toastKey.BOOKS_MANAGEMENT.LIST.DEACTIVE
            )
            window.location.reload()
            return
          }
          const textError =
            dataInfoBook.status !== 'INACTIVE'
              ? 'Vô hiệu hóa sách thất bại'
              : 'Kích hoạt sách thất bại'
          showErrorToast({
            message: textError,
            error: error.message,
            toastId: toastKey.BOOKS_MANAGEMENT.LIST.DEACTIVE,
          })
        } catch (error) {
          throw new Error(error.message || 'Lỗi không xác định!')
        }
      }
    } catch (error) {
      throw new Error(error.message || 'Lỗi không xác định!')
    }
  }
  const actionButtons = [
    {
      title: 'Chỉnh sửa',
      icon: (
        <Icon
          icon="ph:pencil-simple-line"
          className={'text-2xl text-main-grey'}
        />
      ),
      onClick: (row) => {
        navigate(PATH.BOOK.EDIT(row.uuid))
      },
      label: 'Xem',
    },
    {
      title: 'Vô hiệu hóa',
      icon: <LuEye className={'text-2xl font-light text-main-grey'} />,
      onClick: (row) => {
        if (row.status === 'INACTIVE') {
          setCheckStatus('INACTIVE')
        } else {
          setCheckStatus('ACTIVE')
        }
        setActiveBook(row)
        setActiveModal(true)
        // handleDeactiveBook(row)
      },
      label: 'Vô hiệu hóa sách',
    },
  ]
  return (
    <>
      <TableData
        data={books}
        columnMapping={columnMapping}
        columnWidths={columnWidths}
        detailView={detailViewFunction}
        actionButtons={actionButtons}
        paginationEnabled={true}
        dataType="quyển sách"
        currentPage={currentPage + 1}
        totalPages={totalPages}
        pageSize={PAGE_SIZE}
        totalItems={totalResult}
        path={path}
        extraFunctions={[
          <Button
            variant={'primary'}
            onClickHandler={() => navigate(PATH.BOOK.UPLOAD_SINGLE)}
            className={'gap-2 whitespace-nowrap'}
          >
            <Icon
              icon="ph:plus"
              width="24px"
              height="24px"
              style={{ color: 'white' }}
            />
            Tạo sách
          </Button>,
          <ExportExcelBook />,
        ]}
      />
      {activeBook && (
        <BookDetailModal
          uuid={activeBook}
          closeHandler={() => {
            setActiveBook(null)
          }}
        />
      )}
      {
        // thực thi logic popUp
        activeModal && (
          <ConfirmationBox
            message={`${checkStatus === 'INACTIVE' ? 'Xác nhận kích hoạt sách ?' : 'Xác nhận vô hiệu hóa sách ?'}`}
            onConfirm={() => handleDeactiveBook(activeBook)}
            onCancel={() => setActiveModal(false)}
            className={`${checkStatus === 'INACTIVE' ? 'text-main-red' : 'text-[#145CA8]'}`}
          />
        )
      }
    </>
  )
}
